"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("../icon-base"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var FaQuestion = function FaQuestion(props) {
  return _react.default.createElement(_iconBase.default, props, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M704 1256v240q0 16-12 28t-28 12H424q-16 0-28-12t-12-28v-240q0-16 12-28t28-12h240q16 0 28 12t12 28zm316-600q0 54-15.5 101t-35 76.5-55 59.5-57.5 43.5-61 35.5q-41 23-68.5 65t-27.5 67q0 17-12 32.5t-28 15.5H420q-15 0-25.5-18.5T384 1096v-45q0-83 65-156.5T592 786q59-27 84-56t25-76q0-42-46.5-74T547 548q-65 0-108 29-35 25-107 115-13 16-31 16-12 0-25-8L112 575q-13-10-15.5-25t5.5-28q160-266 464-266 80 0 161 31t146 83 106 127.5 41 158.5z"
  })));
};
FaQuestion.defaultProps = {
  viewBox: '0 0 1057.212 1896.083',
  height: '1em',
  width: '0.5576em'
};
FaQuestion.displayName = 'FaQuestion';
var _default = FaQuestion;
exports.default = _default;